import { IconDashboard, IconLicense, IconUserCircle } from '@tabler/icons-react';

export const data = [
  { link: '/dashboard', label: 'Dashboard', icon: IconDashboard },
  { link: '/request-permit', label: 'Request', icon: IconLicense },
  { link: '/profile', label: 'Account', icon: IconUserCircle },
];